angular.module("questionarioAdv.module")
    .component("documentoAdv", {
        templateUrl: "ng/components/questionarioAdv/documentoAdv/documentoAdv.view.html",
        bindings: {
            model: '<',
            enabledPrint: '<',
            validateComponent: '&',
            readOnly: '<'
        },
        controller: DocumentoAdv,
        controllerAs: "documentoAdvCtrl"
    })

function DocumentoAdv(
    FileUploader,
    $timeout,
    $download,
    $simulationService,
    $configService,
    $rootScope,
    $uniService
) {

    var self = this;

    self.$onInit = function () {
        console.log("Component is rendering");
        self.loadingStatus = {
            uploading: false,
        };
        self.listOfFilesUpload = {
            uploadedFiles: []
        }

        if (self.model && self.model.metadataAdv && self.model.metadataAdv.documento && self.model.metadataAdv.documento.uuid) {
            var tmp = {
                filename: self.model.metadataAdv.documento.filename,
                id: self.model.metadataAdv.documento.uuid,
                cdDoc: '',
                status: "1",
                downloadKey: self.model.metadataAdv.documento.uuid
            };
            self.listOfFilesUpload.uploadedFiles.push(tmp)
        }

        checkIfFileRequestIsUploaded();
    }

    self.$onChanges = function (changes) {
        if (changes.enabledPrint && typeof changes.enabledPrint.currentValue != 'undefined') {
            self.enabledPrint = changes.enabledPrint.currentValue;
        }
    }

    self.printQuestAdv = function () {
        self.loaderPrint = true;
        $uniService.printAdv(self.model)
            .then(function (response) {
                console.log(response)
                self.loaderPrint = false;
                self.documentPrinted = true;
            })
            .catch(function (error) {
                console.log(error);
                self.loaderPrint = false;
            })

    }

    // inizio procedura upload file
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (item) {
            self.uploadData = item;
        }
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
        self.isSplit = arguments[4] && arguments[4];
        self.singleFile = self.listOfFilesUpload;
    };

    self.finalUpload = function () {
        self.disabledForUploadingInProgress = true;
        var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos/";
        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = url;
        }
        self.loadingStatus.uploading = true;
        var filesUpload = document.querySelector(
            "#uploadInput_document"
        ).files;
        filesUpload = Object.keys(filesUpload).map(function (key) {
            return filesUpload[key];
        });
        var formData = new FormData();

        jQuery("#uploadInput_document").val("");
        filesUpload.forEach(function (file) {
            formData = new FormData();
            appendToForm(formData, "file", file);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "id", self.model.id);

            $uniService
                .saveDocumentAdv(formData)
                .then(function (response) {
                    if (response.success) {
                        $timeout(function () {
                            var tmp = {
                                filename: file.name,
                                id: response.id,
                                cdDoc: response.cdDocNsil,
                                status: "1",
                                downloadKey: response.downloadKey
                            };

                            self.visualProgBarDoc = false;
                            self.listOfFilesUpload.uploadedFiles.push(tmp);
                            self.listOfFilesUpload.status =
                                "1";
                            self.disabledForUploadingInProgress = false;
                            checkIfFileRequestIsUploaded();
                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                        self.disabledForUploadingInProgress = false;
                        checkIfFileRequestIsUploaded();
                    }

                })
                .catch(function (error) {
                    checkIfFileRequestIsUploaded();
                    self.disabledForUploadingInProgress = false;
                    self.visualProgBarDoc = false;
                });
        });

    };


    self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
        console.info("onWhenAddingFileFailed", item, filter, options);
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        self.disabledForUploadingInProgress = true;
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("#uploadInput_document").val("");
            self.disabledForUploadingInProgress = false;
            return;
        }

        var fileName = fileItem.file.name;

        if (
            fileName.toLowerCase().indexOf(".pdf") > -1 ||
            fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
            self.visualProgBarDoc = true;
            self.uploader.queue[0].progress = 100;

            $timeout(function () {
                self.progresso = 100;
            }, 500);
        } else {
            fileItem.remove();
            jQuery("#uploadInput_document").val("");
            $rootScope.$broadcast("addAlert", {
                text: "FORMAT_NOT_SUPPORTED",
            })
        }

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 100;
        }, 500);
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disabledForUploadingInProgress = true;
        self.uploadInProgess({
            uploadInProgess: true,
        });
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.loadingStatus.uploading = false;
    };

    self.uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info("onErrorItem", fileItem, response, status, headers);
        self.loadingStatus.uploading = false;
        jQuery("#uploadInput_document").val("");

        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        self.disabledForUploadingInProgress = false;
        self.uploadInProgess({
            uploadInProgess: false,
        });
        $timeout(function () {
            self.visualProgBarDoc = false;
        }, 1);

        fileItem.remove();
        jQuery("#uploadInput_document").val("");
    };

    self.uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {
            self.uploadOk = true;
            console.log(fileItem);

            var document = {
                fileStatus: null,
                isSelected: false,
                nameFile: response.uploadFileServicePojo.fileName,
                uuid: "",
                errorMessage: "",
                documentClass: "",
            };

            self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
                function (a, b) {
                    if (a.codiceDocNSIL > b.codiceDocNSIL) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            );
        }
        self.uploader.queue = [];

        $timeout(function () {
            self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

            self.disabledForUploadingInProgress = false;
            self.uploadInProgess({
                uploadInProgess: false,
            });
        }, 1);
        jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    };

    // fine processo upload

    self.downloadFile = function (file) {
        var input = {
            downloadKey: file.downloadKey
        }
        var url = "/uni/downloadDocDigital/service-infos/"
        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })
    }

    self.deletePrivacyDocument = function (index) {
        self.progresso = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 0;
        }, 200);

        self.documentsToBeDeleted = self.listOfFilesUpload.uploadedFiles.filter(function (elem) {
            return elem.isSelected == true;
        });

        self.documentsToBeDeleted.forEach(function (element) {
            var checklistType = undefined;
            $simulationService
                .deleteChecklistFileAdv(element.downloadKey, checklistType)
                .then(function (response) {
                    console.log(response);
                    if (response.success) {
                        $timeout(function () {
                            self.visualProgBarDoc = false;
                            self.listOfFilesUpload.uploadedFiles = self.listOfFilesUpload.uploadedFiles.filter(function (e) {
                                return e.isSelected != true;
                            });
                            checkIfFileRequestIsUploaded();


                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                        self.uploadOk = false;
                        checkIfFileRequestIsUploaded();
                    }

                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "ERROR_TEC",
                    });
                    self.checkStatusOfFile();
                    checkIfFileRequestIsUploaded();
                });
        });
    };

    var checkIfFileRequestIsUploaded = function () {
        if (self.listOfFilesUpload && self.listOfFilesUpload.uploadedFiles && self.listOfFilesUpload.uploadedFiles.length) {

            self.validateComponent({ valid: true });
        } else {
            self.validateComponent({ valid: false });
        }
    }

    self.check = function (el) {
        el.isSelected = !el.isSelected;
    };

    self.genericTrashCheck = function () {

        return self.listOfFilesUpload &&
            self.listOfFilesUpload.uploadedFiles.some(x => x.isSelected);
    }

}